import { translate } from 'react-translate'

import DeviceType from './device-type-modal'

export default translate('DeviceType')(DeviceType)
